// extracted by mini-css-extract-plugin
export default {"container":"StatementsNavigation_container__lFXk3","counter":"StatementsNavigation_counter__VP-rO"};